
export default {
  props: ["date"]
};
